import { createFileRoute } from '@tanstack/react-router';

import { NotFound404 } from '@/shared/components/layouts';

export const Route = createFileRoute('/$')({
  component: NotFound404,
});
